import { Box } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { B4RemainingTime, J2Validate } from '@e3dc-react/icons'
import { ContractStateProps, ExtensionStates } from '../../types'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}))

/**
 * This component displays the current contract state of an extension.
 */
const ContractState: React.FC<ContractStateProps> = ({ contractState, displayText = true, hasEmptyPlaceholder = false, isLoading = false, sx }) => {
  const { classes } = useStyles()

  if (isLoading) return null

  if (contractState === ExtensionStates.Pending) {
    return (
      <Box className={classes.container} sx={{ ...sx }}>
        <B4RemainingTime />
        {displayText && <Typography variant="overline">{'installation-extensions.direct-marketing.contract-status.pending'}</Typography>}
      </Box>
    )
  }

  if (contractState === ExtensionStates.Active) {
    return (
      <Box className={classes.container} sx={{ ...sx }}>
        <J2Validate sx={theme => ({ color: theme.palette.primary.main })} />
        {displayText && <Typography variant="overline">{'installation-extensions.direct-marketing.contract-status.signed'}</Typography>}
      </Box>
    )
  }

  if (!contractState && hasEmptyPlaceholder) {
    return <Box sx={{ height: 24, width: 24 }} />
  }

  return <></>
}
export default ContractState
